import React from 'react';

import AmbientTemperature from 'src/screen/v2/Protected/DashboardScreen/AmbientTemperature';
import AreaFilter from 'src/component/v2/AreaFilter';
import FacilityMap from 'src/screen/v2/Protected/DashboardScreen/FacilityMap';

export interface MapHeaderProps {
  toggle: React.ReactNode;
  deviceSummary: React.ReactNode;
  showForecast?: boolean;
}

export default function MapHeader ({ toggle, deviceSummary, showForecast = true }: MapHeaderProps) {
  return (
    <div className='ds-relative'>
      <div className='ds-absolute ds-left-0 ds-right-0 ds-top-0 ds-z-30 ds-flex ds-items-start ds-justify-between ds-gap-4 ds-p-3.5'>
        <AreaFilter className='ds-min-w-0 ds-flex-1' />
        <div className='ds-flex ds-shrink-0 ds-items-start ds-gap-4'>
          {toggle}
          {showForecast && <AmbientTemperature />}
        </div>
      </div>

      <FacilityMap bottomLeft={deviceSummary} />
    </div>
  );
}
